import { PageHeader, Input } from "antd";

import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { createComponentStore, useStoreState } from "easy-peasy";
import React, { useEffect } from "react";
import { isScreenMobile } from "Utils";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import AuthorizationsTable from "./components/table";

const { Search } = Input;

const useUserStore = createComponentStore(UserStoreModel);

export default function AuthorizationsPage({ ...props }) {
  const { abilities } = useStoreState((store) => store.auth);
  const [store, actions] = useUserStore();
  const IsAuthorized = AuthCheck(abilities, AUTH_ACTIONS.READ, "Yetkiler");

  useEffect(() => {
    if (IsAuthorized) actions.getAuths();
  }, [IsAuthorized]);

  return (
    <>
      <PageHeader
        title="Yetkiler"
        className={
          isScreenMobile() ? "mobile-customized customized" : "customized"
        }
      />
      <div style={{ marginTop: 20 }}>
        <AuthorizationsTable
          IsAuthorized={IsAuthorized}
          data={store.auths}
          loading={process === ACTION_TYPES.FETCHING_AUTHS}
        />
      </div>
    </>
  );
}
